/**
 * How a number moved against the period before, as a whole percentage.
 * `null` when there is nothing to compare: both zero. `'new'` when the
 * previous period was zero, where a percentage would be infinite.
 */
export function percentChange(current: number, previous: number): number | 'new' | null {
  if (previous === 0) return current === 0 ? null : 'new'
  return Math.round(((current - previous) / previous) * 100)
}

export type Momentum = 'up' | 'down' | 'flat' | 'start'

/**
 * The one-line verdict under the headline. Within 5% either way reads as the
 * same pace; a nudge that small is noise, not a trend worth congratulating.
 */
export function momentum(current: number, previous: number): Momentum {
  if (current === 0 && previous === 0) return 'start'
  const change = percentChange(current, previous)
  if (change === 'new') return 'up'
  if (change === null || Math.abs(change) < 5) return 'flat'
  return change > 0 ? 'up' : 'down'
}

/** Minutes as "2h 15m", "45m" or "0m". */
export function formatDuration(minutes: number): string {
  const h = Math.floor(minutes / 60)
  const m = Math.round(minutes % 60)
  if (h === 0) return `${m}m`
  return m === 0 ? `${h}h` : `${h}h ${m}m`
}
